let isRedirecting = false;

/**
 * Guard so AuthGuard does not trigger login() when we are in the same tab
 * and have just called logout() (which sets user to null before redirecting).
 * Without this, AuthGuard sees isAuthenticated=false and redirects to login,
 * racing with the Cognito logout redirect.
 */
let logoutInProgress = false;

export function setLogoutInProgress(value: boolean): void {
  logoutInProgress = value;
}

export function isLogoutInProgress(): boolean {
  return logoutInProgress;
}

/**
 * Cross-module guard to prevent "redirect stampedes" where multiple callers
 * trigger interactive login simultaneously (e.g. page boot + concurrent 401s).
 *
 * This is intentionally module-scoped (not React state) so it can be shared by:
 * - `lib/auth/AuthProvider.tsx`
 * - `lib/auth/handle401Error.ts`
 */
export function startInteractiveRedirectOnce(): boolean {
  if (isRedirecting) return false;
  isRedirecting = true;
  return true;
}

export function resetInteractiveRedirectGuard(): void {
  isRedirecting = false;
}

export function resetLogoutGuard(): void {
  logoutInProgress = false;
}

export function isInteractiveRedirectInFlight(): boolean {
  return isRedirecting;
}

